import ProviderInForm from "components/ProviderIn/form"
import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import SAlert from "components/Alert"
import {
  getProviderIps,
  getProviderCommodityClassifications,
  getProviderFundCodes,
  getProviderShipments,
  getProviderProjects,
  getProviderProviders,
  getProviderWarehouses,
} from "store/provider-dashboard/provider-dashboard-action"
import { getAllCurrencies } from "store/general-renders/general-action"
import {
  storeProviderIn,
  storeProviderInDraft,
  getProviderInDrafts,
  updateDraftsToSubmitted,
  deleteProviderInDraft,
  deleteManyProviderInDrafts,
} from "store/provider-in/provider-in-action"

const AddProviderIn = () => {
  document.title = "Add Receipts"
  const navigate = useNavigate()
  const dispatch = useDispatch()

  // FIX: Correct selector for drafts
  const draftsData = useSelector(state => state.providerIn.drafts?.data || [])
  const draftsLoading = useSelector(
    state => state.providerIn.drafts?.loading || false
  )
  const draftsError = useSelector(state => state.providerIn.drafts?.error)

  // Main loading state for form submissions
  const loading = useSelector(state => state.providerIn.loading)
  const error = useSelector(state => state.providerIn.error)

  const warehosues = useSelector(
    state => state.providerDashboard.providerWarehouses
  )
  const providers = useSelector(
    state => state.providerDashboard.providerProviders
  )
  const commodityClassifications = useSelector(
    state => state.providerDashboard.ProviderCommodityClassifications
  )
  const categories = useSelector(
    state => state.providerDashboard.ProviderItemCategoires
  )
  const projects = useSelector(
    state => state.providerDashboard.providerProjects
  )
  const fundCodes = useSelector(
    state => state.providerDashboard.ProviderFundCodes
  )
  const shipments = useSelector(
    state => state.providerDashboard.ProviderShipments
  )
  const items = useSelector(state => state.providerDashboard.ProviderItems)
  const currencies = useSelector(state => state.generalRenders.currencies)

  // Fetch drafts on component mount
  useEffect(() => {
    dispatch(getProviderInDrafts())
  }, [dispatch])

  // FIX: Add missing function for "Save as Draft" button
  const handleDraftSubmit = (values, file) => {
    const forms = new FormData()
    forms.append("document", file)
    forms.append("receipts", JSON.stringify(values))

    dispatch(storeProviderInDraft(forms))
  }

  // FIX: Final submit - change draft status to submitted (for "Save All Drafts" button)
  const handleFinalSubmit = () => {
    if (draftsData.length === 0) {
      SAlert({ text: "No drafts to submit", status: "warning" })
      return
    }
    dispatch(updateDraftsToSubmitted(navigate))
  }

  // Edit mode submit (for existing records)
  const handleEditSubmit = (values, file) => {
    const forms = new FormData()
    forms.append("document", file)
    forms.append("receipts", JSON.stringify(values))
    dispatch(storeProviderIn(forms, navigate))
  }

  // Delete single draft
  const handleDeleteDraft = draftId => {
    dispatch(deleteProviderInDraft(draftId))
  }

  // Delete multiple drafts
  const handleDeleteManyDrafts = draftIds => {
    if (draftIds.length > 0) {
      dispatch(deleteManyProviderInDrafts(draftIds))
    } else {
      SAlert({ text: "No drafts selected", status: "info" })
    }
  }

  useEffect(() => {
    dispatch(getProviderWarehouses())
    dispatch(getProviderProviders())
    dispatch(getProviderCommodityClassifications())
    dispatch(getProviderFundCodes())
    dispatch(getProviderShipments())
    dispatch(getProviderProjects())
    dispatch(getAllCurrencies())
  }, [dispatch])

  // Debug: Check if drafts are being fetched
  useEffect(() => {
    if (draftsError) {
      console.error("Error fetching drafts:", draftsError)
    }
  }, [draftsData, draftsLoading, draftsError])

  return (
    <ProviderInForm
      onSubmit={handleDraftSubmit} // For "Save as Draft" button
      onDraftSubmit={handleFinalSubmit} // For "Save All Drafts" button
      onEditSubmit={handleEditSubmit}
      onDeleteDraft={handleDeleteDraft}
      onDeleteManyDrafts={handleDeleteManyDrafts}
      loading={loading}
      error={error}
      formMode={"Add"}
      warehosues={warehosues?.data}
      providers={providers?.data}
      commodityClassifications={commodityClassifications?.data}
      categories={categories?.data || []}
      items={items?.data}
      projects={projects?.data}
      fundCodes={fundCodes?.data}
      shipments={shipments?.data}
      currencies={currencies}
      drafts={draftsData} // Pass the actual drafts array
      draftsLoading={draftsLoading} // Pass drafts loading state separately
    />
  )
}

export default AddProviderIn
